// 渲染延迟 (ms)
export const RESIZE_RENDER_DELAY = 200;
